module.exports = __webpack_public_path__ + "img/rashi-ocr.f33caeb8.png";